import { Box, Button, Typography, ButtonProps, useTheme, LinearProgress } from "@mui/material";
import React, { useEffect } from "react";
import * as entityExpirationPeriodService from "services/entityExpirationPeriodService";
import { useTranslation } from "react-i18next";
import { AxiosError } from "axios";
import * as Styles from "pages/development/settings/tabs/expirationPeriods/expirationPeriods.styles";
import ExpirationPeriodsList from "./expirationPeriodsList";
import { IPropsSettings } from "../../Settings";


const ExpirationPeriods = (props: IPropsSettings) => 
{
    const { tenantId } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [loading, setLoading] = React.useState<boolean>(false);
    const [isUpdating, setIsUpdating] = React.useState(false)

    let [entityExpirationPeriods, setEntityExpirationPeriods] = React.useState<EntityExpirationPeriod[]>([]);

    const showError = (message: string) => {
        setErrorMessage(message);
        setShowErrorMessage(true);
    };  

    const fetchRequests = () => {
        setShowErrorMessage(false);
        setErrorMessage("");
        setLoading(true);
        entityExpirationPeriodService
          .getEntityExpirationPeriods(tenantId)
          .then((res: EntityExpirationPeriod[]) => {
            res.forEach(function(value) {
                value.newValueInyears = value.expirationInYears;
            });
            setEntityExpirationPeriods(res);
            setLoading(false);
          })
          .catch((error: AxiosError<Error>) => {
            setLoading(false);
            showError(`${t("errors.500")}`);
        });
    };

    const buttonRetryProps: ButtonProps = {
        onClick: fetchRequests,
        style: {textTransform: "unset", marginTop: "10px"}
    }

    function handleChangeYears(event: any, entityExpiration: EntityExpirationPeriod, button: string|null) {
        setIsUpdating(false);
        setShowErrorMessage(false);
        setErrorMessage("");
        var index = entityExpirationPeriods.findIndex(a => a.id === entityExpiration.id);
        let temp = [...entityExpirationPeriods];
        let item = {...entityExpirationPeriods[index]}
        if (button) {
            if (button === 'save') {
                setIsUpdating(true);
                item.expirationInYears = item.newValueInyears;
                entityExpirationPeriodService
                .updateEntityExpirationPeriods(item, tenantId)
                .then((res: EntityExpirationPeriod) => {
                    item.newValueInyears = res.expirationInYears;
                    item.expirationInYears = res.expirationInYears;
                    temp[index] = item;
                    setEntityExpirationPeriods(temp);
                    setIsUpdating(false);
                })
                .catch((error: AxiosError<Error>) => {
                    showError(`${t("errors.500")}`);
                });
            }
            else if (button === 'delete') {
                item.newValueInyears = item.expirationInYears;
            }
        }
        else {
            item.newValueInyears = event.target.value;
        }
        
        if (button !== 'save') {
            temp[index] = item;
            setEntityExpirationPeriods(temp);
        }  
    }


    useEffect(() => {
        fetchRequests();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantId]);


    return (
        <Box>
            <Typography variant='h4'>
                {t('settings.expirationPeriods.title')}
            </Typography>
            <Box>
                {t('settings.expirationPeriods.description')}
            </Box>
            {loading && (
                <Box sx={{ marginTop: '1rem' }}>
                    <LinearProgress/>
                </Box>
            )}
            {!loading && (
                <Box sx={Styles.wrapper(theme)}>
                    <Box sx={{padding: '15px'}}>
                        <Box sx={{width: "100%", textAlign: "center"}}>
                            { showErrorMessage && 
                                <Box color="error.main">
                                    {errorMessage}
                                    <br></br>
                                    { !isUpdating && <Button {...buttonRetryProps} color="error" variant="outlined">{t("buttons.tryAgain")}</Button> }
                                </Box>
                            }
                        </Box>

                        <Box>
                            <h2 style={{textAlign: "center", textDecoration: "underline"}}>{t("settings.expirationPeriods.applications")}</h2>
                        </Box>
                        <ExpirationPeriodsList handleChangeYears={handleChangeYears} expirationPeriods={entityExpirationPeriods.filter((obj) => { return obj.entityType === "Application"})}/>


                        <Box>
                            <h2 style={{textAlign: "center", textDecoration: "underline"}}>{t("settings.expirationPeriods.certificates")}</h2>
                        </Box>
                        <ExpirationPeriodsList handleChangeYears={handleChangeYears} expirationPeriods={entityExpirationPeriods.filter((obj) => { return obj.entityType === "Certificate"})}/>
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default ExpirationPeriods;